import { Box, Text, Touchable } from '@factorialco/deprecated-design-system'
import { ProjectManagementProjectEmployeesAssignmentEnum } from 'generated/resources/graphql'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import RadioInput from 'modules/core/components/Inputs/FilterSelect/SelectOption/RadioInput'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelector } from 'modules/employees/components/EmployeeSelector'

interface IEmployeeAssignmentSelectorProps {
  includeInactive?: boolean
  isManualSelected: boolean
  onSelectEmployees: (newEmployees: EmployeeForSelectFragmentNoAccess[]) => void
  selectedEmployees: EmployeeForSelectFragmentNoAccess[]
  toggleAssignmentSelection: (value: ProjectManagementProjectEmployeesAssignmentEnum) => void
}

const EmployeeAssignmentSelector = ({
  includeInactive = false,
  isManualSelected,
  onSelectEmployees,
  selectedEmployees,
  toggleAssignmentSelection,
}: IEmployeeAssignmentSelectorProps) => {
  return (
    <Box gap="s16">
      <Box
        gap="s16"
        border={{
          all: {
            width: 's2',
            style: 'solid',
            color: !isManualSelected ? 'viridian1000' : 'grey400',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
        padding="s16"
      >
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Text.Normal weight="semibold">
            {i18n.t('project_management.modals.assign_employees.options.company.title')}
          </Text.Normal>
          <Touchable
            onClick={() => toggleAssignmentSelection('company')}
            autofocus={!isManualSelected}
          >
            <RadioInput selected={!isManualSelected} />
          </Touchable>
        </Box>
        <Text.Normal>
          {i18n.t('project_management.modals.assign_employees.options.company.description')}
        </Text.Normal>
      </Box>
      <Box
        background="grey100"
        borderRadius={{
          all: 'abs008',
        }}
      >
        <Box
          gap="s16"
          border={{
            all: {
              width: 's2',
              style: 'solid',
              color: isManualSelected ? 'viridian1000' : 'grey400',
            },
          }}
          borderRadius={{
            all: 'abs008',
          }}
          padding="s16"
          width="fit-content"
          background="grey000White"
        >
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text.Normal weight="semibold">
              {i18n.t('project_management.modals.assign_employees.options.manual.title')}
            </Text.Normal>
            <Touchable
              onClick={() => toggleAssignmentSelection('manual')}
              autofocus={isManualSelected}
            >
              <RadioInput selected={isManualSelected} />
            </Touchable>
          </Box>
          <Text.Normal>
            {i18n.t('project_management.modals.assign_employees.options.manual.description')}
          </Text.Normal>
        </Box>
        {isManualSelected && (
          <Box padding="s16">
            <EmployeeSelector
              multiple
              alwaysOpen
              includeInactive={includeInactive}
              onSelect={onSelectEmployees}
              value={selectedEmployees}
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default EmployeeAssignmentSelector
